import React, { useCallback } from "react";
import { Image } from "react-bootstrap";
import { useAtom } from "jotai";

import "./ChallengeResponseModal.scss";
import GhostButton from "../../../dashboard-page/GhostButton/GhostButton";
import BottomDrawer from "../../../BottomDrawer/BottomDrawer";
import HyperCoin from "../../../HyperCoin/HyperCoin";
import GetAppButton from "../../../GetAppButton/GetAppButton";
import useDisclosure from "../../../../hooks/useDisclosure";
import ImageRedX from "../../../../images/red-x-rounded.svg";
import {
  selectedChallengeResponseAtom,
  useIsChallengeResponseModalOpen,
} from "../../../../jotai/atoms/challenges";
import useAuth from "../../../../hooks/useAuth";
import DownloadAndroidAppModal from "../../../DownloadAndroidAppModal/DownloadAndroidAppModal";
import useHprFiatFormatter from "../../../../hooks/useHprFiatFormatter";
import { useTranslation } from "react-i18next";

function ChallengeResponseModal({
  onRemindMeLater,
}: {
  onRemindMeLater: () => void;
}) {
  const [selectedChallengeResponse] = useAtom(selectedChallengeResponseAtom);
  const { isChallengeResponseModalOpen, closeChallengeResponseModal } =
    useIsChallengeResponseModalOpen();
  const isDecline = !!selectedChallengeResponse?.isDecline;
  const { onOpen: openTestFlightInstructions } = useDisclosure();
  const {
    isOpen: isAndroidAppDownloadOpen,
    onOpen: openDownloadAndroidApp,
    onClose: closeDownloadAndroidApp,
  } = useDisclosure();
  const { userProfile } = useAuth();
  const { isFiatDisplay, formatHprToFiatValue } = useHprFiatFormatter();
  const { t } = useTranslation();

  const challengerUsername =
    selectedChallengeResponse?.challenge?.initiator.username;
  const challengerAvatar =
    selectedChallengeResponse?.challenge?.initiator?.avatarUrl;
  const challengeGame = selectedChallengeResponse?.challenge?.game;
  const rewardAmount = selectedChallengeResponse?.challenge?.rewardAmount;
  const headingText = isDecline
    ? `Decline @${challengerUsername}`
    : `@${challengerUsername} challenged you!`;
  const subheadText = isDecline
    ? "Get the app to decline their challenge."
    : "Get the app to accept their challenge and show them who's boss.";

  const handleDownloadApp = useCallback((openPlatformDialog: () => void) => {
    openPlatformDialog();
  }, []);

  return (
    <BottomDrawer
      isOpen={isChallengeResponseModalOpen}
      onClose={closeChallengeResponseModal}
    >
      <div className="challenge-response-modal">
        <div className="avatars mt-5 mb-3">
          <div className="avatar-rounded-wrapper">
            <Image alt="" src={userProfile?.avatar?.url} />
          </div>
          <div
            className="avatar-rounded-wrapper"
            style={{
              left: -24,
              background: "#C6EFEA",
            }}
          >
            <Image alt="" src={challengerAvatar} />
          </div>
          {isDecline && <Image alt="" src={ImageRedX} className="red-x" />}
        </div>
        <div className="has-already-played d-flex align-items-center mb-4">
          <span className="img-wrapper">
            <Image alt="" src={challengerAvatar} />
          </span>
          <span className="text">@{challengerUsername} has already played</span>
        </div>
        {!isDecline && (
          <div className="info-container d-flex w-100 justify-content-between mb-5">
            <div className="info">
              <p className="info-heading">
                <Image
                  alt=""
                  src={challengeGame?.thumbnail}
                  height={24}
                  width={24}
                />
              </p>
              <p className="info-content">
                <span
                  className="truncate ms-2 d-inline-block"
                  style={{ maxWidth: 150 }}
                >
                  {challengeGame?.name}
                </span>
              </p>
            </div>
            <div className="info center-info">
              <p className="info-heading" style={{ marginBottom: 12 }}>
                {t("winner_gets")}
              </p>
              <p className="info-content">
                {!isFiatDisplay && <HyperCoin height={20} width={20} />}{" "}
                {isFiatDisplay
                  ? formatHprToFiatValue(rewardAmount)
                  : rewardAmount}
              </p>
            </div>
          </div>
        )}
        <h2 className="heading-text">{headingText}</h2>
        <p className="subhead-text mb-4">{subheadText}</p>
        <GetAppButton
          openDownloadAndroidApp={() =>
            handleDownloadApp(openDownloadAndroidApp)
          }
          openTestFlightInstructions={() =>
            handleDownloadApp(openTestFlightInstructions)
          }
        />
        <GhostButton className="remind-btn" onClick={onRemindMeLater}>
          Remind me later
        </GhostButton>
      </div>
      <DownloadAndroidAppModal
        isOpen={isAndroidAppDownloadOpen}
        onClose={closeDownloadAndroidApp}
      />
    </BottomDrawer>
  );
}

export default ChallengeResponseModal;
